// src/App.js
import React from 'react';
import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';

import TopBar from './components/TopBar';
import NavBar from './components/NavBar';
import HeroSlider from './components/HeroSlider';
import WhySection from './components/WhySection';
import EducationSection from './components/EducationSection';
import StaffSection from './components/StaffSection';
import AboutSection from './components/AboutSection';
import ZezeSection from './components/ZezeSection';
import ServicesSection from './components/ServicesSection';
import HumanResourcesSection from './components/HumanResourcesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import NewsSection from './components/NewsSection';
import VideoSection from './components/VideoSection';

// Sayfa bileşenleri
import AnaokuluPage from './pages/AnaokuluPage';
import IlkokulOrtaokulPage from './pages/IlkokulOrtaokulPage';
import LiseYksVipPage from './pages/LiseYksVipPage';
import SkillsArtSportPage from './pages/SkillsArtSportPage';
import RehberlikPage from './pages/RehberlikPage';
import DilEgitimPage from './pages/DilEgitimPage';
import Kurumsal from './pages/Kurumsal';
import Zeze from './pages/Zeze';
import Contact from './pages/Contact';
import Kariyer from './pages/Kariyer';

import './index.css';
import './App.css';


// ---------------------------------------------
// HOME BİLEŞENİ
// ---------------------------------------------
function Home() {

  return (
    <>
      <TopBar />
      <NavBar />

      <HeroSlider />
      <WhySection />
      <EducationSection />
      <NewsSection />
      <StaffSection />
      <VideoSection />
      <HumanResourcesSection />
      <ContactSection />
      <Footer />
    </>
  );
}



// ---------------------------------------------
// ROUTER
// ---------------------------------------------
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/kurumsal" element={<Kurumsal />} />
        <Route path="/zeze" element={<Zeze />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/anaokulu" element={<AnaokuluPage />} />
        <Route path="/ilkokul-ortaokul" element={<IlkokulOrtaokulPage />} />
        <Route path="/dikmen-kurs-lise-yks-vip" element={<LiseYksVipPage />} />
        <Route path="/skills-art-sport" element={<SkillsArtSportPage />} />
        <Route path="/rehberlik" element={<RehberlikPage />} />
        <Route path="/dil-egitim" element={<DilEgitimPage />} />
        <Route path="/kariyer" element={<Kariyer />} />
        <Route path="/basvuru" element={<Navigate to="/kariyer" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
